import { render, staticRenderFns } from "./SiteNotAvailableBM100-gt2.vue?vue&type=template&id=51925452&scoped=true"
import script from "./SiteNotAvailableBM100-gt2.vue?vue&type=script&lang=js"
export * from "./SiteNotAvailableBM100-gt2.vue?vue&type=script&lang=js"
import style0 from "./SiteNotAvailableBM100-gt2.vue?vue&type=style&index=0&id=51925452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51925452",
  null
  
)

export default component.exports